import * as React from 'react';
export var FooterMenu = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement("div", { className: "footer-menu" },
        React.createElement("h3", null, title),
        React.createElement("ul", null, children)));
};
//# sourceMappingURL=FooterMenu.js.map